import React from "react";
import {
  ShoppingCart,
  Package,
  CreditCard,
  Truck,
  Users,
  Search,
  Tag,
  BarChart,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Marketplace Development",
    description:
      "Build multi-vendor marketplaces with seller management and ratings",
    icon: ShoppingCart,
  },
  {
    title: "Product Catalog Systems",
    description: "Create scalable product information management solutions",
    icon: Package,
  },
  {
    title: "Payment Integration",
    description: "Implement secure checkout with multiple payment options",
    icon: CreditCard,
  },
  {
    title: "Order & Fulfillment",
    description: "Develop order management and logistics integration systems",
    icon: Truck,
  },
  {
    title: "Customer Experience",
    description: "Build personalized shopping experiences with recommendations",
    icon: Users,
  },
  {
    title: "Search & Discovery",
    description: "Implement AI-powered search and product recommendations",
    icon: Search,
  },
  {
    title: "Promotions & Pricing",
    description: "Dynamic pricing engines and promotional campaign management",
    icon: Tag,
  },
  {
    title: "Analytics & Insights",
    description: "Comprehensive dashboards for sales and customer analytics",
    icon: BarChart,
  },
];

const STATS = [
  { value: "$500M+", label: "GMV Processed" },
  { value: "100+", label: "Marketplaces" },
  { value: "10M+", label: "Products Listed" },
  { value: "99.9%", label: "Uptime" },
];

const EcommerceIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="ecommerce-gig-commerce"
      industryTitle="e-Commerce"
      industrySubtitle="& Gig Commerce"
      heroDescription="Creating powerful online marketplaces and shopping platforms that connect buyers and sellers, streamline transactions, and drive growth in the digital economy."
      themeColor="#ec4899"
      themeColorLight="#f472b6"
      themeGradient="linear-gradient(135deg, #831843 0%, #be185d 50%, #ec4899 100%)"
      HeroIcon={ShoppingCart}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1487014679447-9f8336841d58?q=80&w=1305&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default EcommerceIndustryPage;
